// # #############################################
// # Title : Tab Bar
// # Authors : Atul, Shubham
// # Date : 15th October 2019
// # Last Modified : Shubham, September 2019
// # Version : 19.10.03
// # Description : This is the code for the tabs in the selected div in the Map
// # ############################################

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
// import {Paper} from '@material-ui/core';
import { Tabs } from '@material-ui/core';
import { Tab } from '@material-ui/core';

const styles = {
  root: {
    flexGrow: 1,
  },
  tabLabel: {
    fontSize: "0.9vw"
  }
};

class CenteredTabs extends React.Component {
  state = {
    value: this.props.default,
  };

  handleChange = (event, value) => {
    this.setState({ value });
    this.props.action(event, value);
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Tabs
          value={this.state.value}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          centered
        >

          {this.props.tabContent.map((tab) => {
            return (<Tab label={<span className={classes.tabLabel}>{tab}</span>} />)
          }
          )}

        </Tabs>
      </div>
    );
  }
}

CenteredTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CenteredTabs);









